import React, { useMemo } from 'react';
import { OtpLogin } from '@vaiu/ui';
import { platformApi } from '@/services/platformApi';
import { buildOtpLoginLabels } from '@/i18n/buildOtpLoginLabels';

interface OTPLoginProps {
  onSuccess: (token: string) => void;
  onBack: () => void;
}

const OTPLogin: React.FC<OTPLoginProps> = ({ onSuccess, onBack }) => {
  const labels = useMemo(() => buildOtpLoginLabels(), []);

  return (
    <OtpLogin
      onSuccess={onSuccess}
      onBack={onBack}
      labels={labels}
      api={{
        requestOtp: (identifier, type) => platformApi.requestOtp(identifier, type),
        verifyOtp: (identifier, code, type) => platformApi.verifyOtp(identifier, code, type),
        getOtpStatus: (type, identifier) => platformApi.getOtpStatus(type, identifier),
      }}
    />
  );
};

export default OTPLogin;
